import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const SDKRedirect = () => {
  const { req_id } = useParams();
  const API_KEY = process.env.REACT_APP_DL_CLIENT_ID;

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const { data } = await axios.get(`https://digilocker.myearth.id/v2/api/digilocker/session/${req_id}`);
        console.log('Session Data:', data)
        const url = new URL('https://digilocker.meripehchaan.gov.in/public/oauth2/1/authorize');
        url.searchParams.append('response_type', 'code');
        url.searchParams.append('client_id', API_KEY);
        url.searchParams.append('redirect_uri', 'https://digilocker.myearth.id/v2/api/digilocker/callback');
        url.searchParams.append('scope', 'openid files.uploadeddocs userdetails');
        url.searchParams.append('state', req_id);
        url.searchParams.append('code_challenge', data.code_challenge);
        url.searchParams.append('code_challenge_method', 'S256');
        url.searchParams.append('purpose', data.purpose || 'kyc');
        url.searchParams.append('req_doctype', (data.docs || []).join(','));
        if (data.pinless) url.searchParams.append('pla', 'Y');

        window.location.href = url.toString();
      } catch (err) {
        console.error('Failed to fetch session', err);
      }
    };

    fetchSession();
  }, [req_id]);

  return <p style={{ textAlign: 'center', marginTop: '50px' }}>Redirecting to DigiLocker...</p>;
};

export default SDKRedirect;
